var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMaterialRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.25H15.75V2.5C15.75 1.67 15.08 1 14.25 1H8.25C7.42 1 6.75 1.67 6.75 2.5V3.25H4.5C3.67 3.25 3 3.92 3 4.75V20.5C3 21.33 3.67 22 4.5 22H9V20.5H4.5V4.75H6.75V7H15.75V4.75H18V9.96H19.5V4.75C19.5 3.92 18.83 3.25 18 3.25ZM14.25 5.5H8.25V2.5H14.25V5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5125 13.7275L16.0213 11.1025C15.9017 11.0325 15.7677 10.9985 15.634 11C15.5066 11.0015 15.3794 11.0356 15.2654 11.1018L10.7566 13.7268C10.5259 13.8612 10.384 14.108 10.384 14.375V19.625C10.384 19.892 10.5259 20.1388 10.7566 20.2732L15.2654 22.8982C15.382 22.966 15.5036 23 15.634 23C15.7647 23 15.9043 22.966 16.0213 22.8975L20.5125 20.2725C20.7427 20.1381 20.8841 19.8916 20.8841 19.625V14.375C20.8841 14.1084 20.7427 13.8619 20.5125 13.7275ZM15.6421 12.6183L18.6478 14.375L15.6421 16.1317L12.6247 14.375L15.6421 12.6183ZM11.8841 15.6794L14.8841 17.4262V20.9403L11.8841 19.1935V15.6794ZM16.3841 20.9481V17.4354L19.3841 15.6819V19.1946L16.3841 20.9481Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMaterialRequest);
export default __webpack_public_path__ + "static/media/ic-material-request.35832128f972362c69e83964aed2b3c8.svg";
export { ForwardRef as ReactComponent };